<template>
  <div class="timeSetting">
     <div class="timeSettingItem" v-for="(item,index) in deviceInfo">
       <h4 v-if="deviceInfo.length>1">{{index+1}}路</h4>
       <div class="timeInfo">
          <time-setting-child :device="item"/>
       </div>
     </div>
  </div>
</template>

<script>
  import TimeSettingChild from '@/components/TimeSettingChild.vue'
  export default {
    name:'timesetting',
    props:{
      deviceInfo:{
        type:Array,
        required:true
      }
    },
    data(){
      return {
        tab:['喷药定时设置','排空定时设置'],
        dayList:[],
        timeList:[],
        tabIndex:0,
      }
    },
    mounted(){

    },
    methods:{

    },
    components:{
      TimeSettingChild
    }
  }
</script>

<style scoped>
  .timeSettingItem h4 {margin:0;}
  .timeSettingItem {margin-bottom:30px;}
</style>



// WEBPACK FOOTER //
// src/components/TimeSetting.vue